import { useLocation, useNavigate } from 'react-router-dom';
import { Tabs } from 'antd';
import { useTranslation } from 'react-i18next';

const ADMIN_TABS = [
  { key: '/admin', labelKey: 'admin.dashboard_title' },
  { key: '/admin/tenants', labelKey: 'admin.tenants_title' },
  { key: '/admin/system-settings', labelKey: 'admin.system_settings_title' },
  { key: '/admin/tenant-settings', labelKey: 'admin.tenant_settings_title' },
  { key: '/admin/notification-preferences', labelKey: 'admin.notification_prefs_title' },
  { key: '/admin/branding', labelKey: 'admin.branding_title' },
  { key: '/admin/domains', labelKey: 'admin.domains_title' },
  { key: '/admin/email-templates', labelKey: 'admin.email_templates_title' },
  { key: '/admin/channel-configs', labelKey: 'notification.channel_configs_title' },
];

export default function AdminNav() {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();

  const activeKey = ADMIN_TABS.find(
    (tab) => tab.key !== '/admin'
      ? location.pathname.startsWith(tab.key)
      : location.pathname === '/admin'
  )?.key ?? '/admin';

  return (
    <Tabs
      activeKey={activeKey}
      onChange={(key) => navigate(key)}
      items={ADMIN_TABS.map((tab) => ({
        key: tab.key,
        label: t(tab.labelKey),
      }))}
      style={{ marginBottom: 16 }}
    />
  );
}
